module.exports = __webpack_public_path__ + "img/book-11.c9e7910a.png";